// import React, { useEffect, useState } from 'react';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import axios from 'axios';
// import L from 'leaflet';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

// // Fix default marker icon
// import icon from 'leaflet/dist/images/marker-icon.png';
// import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// let DefaultIcon = L.icon({
//   iconUrl: icon,
//   shadowUrl: iconShadow,
//   iconSize: [25, 41],
//   iconAnchor: [12, 41],
// });

// L.Marker.prototype.options.icon = DefaultIcon;

// function App() {
//   const [users, setUsers] = useState([]);
//   const [viewMode, setViewMode] = useState('map'); // 'map', 'list', 'history', 'monthly'
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [userHistory, setUserHistory] = useState([]);
//   const [loadingHistory, setLoadingHistory] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date()); // For history view
//   const [historicalData, setHistoricalData] = useState([]);
//   const [loadingHistorical, setLoadingHistorical] = useState(false);
//   const [selectedMonth, setSelectedMonth] = useState(new Date()); // For monthly report
//   const [monthlyReport, setMonthlyReport] = useState([]);
//   const [loadingMonthly, setLoadingMonthly] = useState(false);

//   const API_URL = "https://locationapi.hypemarketer.in/api";
//   const LIVE_LOCATIONS_API = `${API_URL}/get_live_locations.php`;
//   const HISTORY_API = `${API_URL}/get_user_history.php`;
//   const HISTORICAL_DATA_API = `${API_URL}/get_historical_data.php`;

//   const PRICE_PER_KM = 2.72; // ₹2.72 per KM

//   // Fetch live locations
//   const fetchLiveLocations = async () => {
//     try {
//       const response = await axios.get(`${LIVE_LOCATIONS_API}?t=${Date.now()}`);
//       if (Array.isArray(response.data)) {
//         setUsers(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching live locations:", error);
//     }
//   };

//   // Fetch user history (for modal)
//   const fetchUserHistory = async (deviceId) => {
//     setLoadingHistory(true);
//     try {
//       const response = await axios.get(`${HISTORY_API}?device_id=${deviceId}&t=${Date.now()}`);
//       setUserHistory(response.data || []);
//     } catch (error) {
//       console.error("Error fetching history:", error);
//       setUserHistory([]);
//     } finally {
//       setLoadingHistory(false);
//     }
//   };

//   // Fetch historical data for a specific date
//   const fetchHistoricalData = async (date) => {
//     setLoadingHistorical(true);
//     try {
//       const formattedDate = date.toISOString().split('T')[0];
//       const response = await axios.get(`${HISTORICAL_DATA_API}?date=${formattedDate}&t=${Date.now()}`);
//       if (Array.isArray(response.data)) {
//         setHistoricalData(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching historical data:", error);
//       setHistoricalData([]);
//     } finally {
//       setLoadingHistorical(false);
//     }
//   };

//   // Fetch monthly report
//   const fetchMonthlyReport = async (monthDate) => {
//     setLoadingMonthly(true);
//     setMonthlyReport([]);

//     const year = monthDate.getFullYear();
//     const month = monthDate.getMonth() + 1;
//     const daysInMonth = new Date(year, month, 0).getDate();

//     const monthlyData = {};

//     try {
//       for (let day = 1; day <= daysInMonth; day++) {
//         const dateStr = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
//         const response = await axios.get(`${HISTORICAL_DATA_API}?date=${dateStr}&t=${Date.now()}`);

//         if (Array.isArray(response.data)) {
//           response.data.forEach(user => {
//             if (!monthlyData[user.device_id]) {
//               monthlyData[user.device_id] = {
//                 name: user.name || 'Unknown User',
//                 device_id: user.device_id,
//                 total_km: 0,
//               };
//             }
//             monthlyData[user.device_id].total_km += user.total_km;
//           });
//         }
//       }

//       const report = Object.values(monthlyData).map(user => ({
//         ...user,
//         total_km: parseFloat(user.total_km.toFixed(2)),
//         pricing: parseFloat((user.total_km * PRICE_PER_KM).toFixed(2)),
//       }));

//       setMonthlyReport(report);
//     } catch (error) {
//       console.error("Error generating monthly report:", error);
//     } finally {
//       setLoadingMonthly(false);
//     }
//   };

//   // Open user details modal
//   const openUserDetails = (user) => {
//     setSelectedUser(user);
//     fetchUserHistory(user.device_id);
//   };

//   // Close modal
//   const closeModal = () => {
//     setSelectedUser(null);
//     setUserHistory([]);
//   };

//   useEffect(() => {
//     fetchLiveLocations();
//     const interval = setInterval(fetchLiveLocations, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     if (viewMode === 'history') {
//       fetchHistoricalData(selectedDate);
//     }
//   }, [selectedDate, viewMode]);

//   useEffect(() => {
//     if (viewMode === 'monthly') {
//       fetchMonthlyReport(selectedMonth);
//     }
//   }, [selectedMonth, viewMode]);

//   return (
//     <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
//       {/* Header */}
//       <div style={{ padding: '15px', backgroundColor: '#1976d2', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <h2 style={{ margin: 0 }}>Live Location Tracker Admin</h2>
//         <div>
//           <button onClick={() => setViewMode('map')} style={{ padding: '10px 20px', marginRight: '10px', backgroundColor: viewMode === 'map' ? 'white' : '#1565c0', color: viewMode === 'map' ? '#1976d2' : 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
//             Map View
//           </button>
//           <button onClick={() => setViewMode('list')} style={{ padding: '10px 20px', marginRight: '10px', backgroundColor: viewMode === 'list' ? 'white' : '#1565c0', color: viewMode === 'list' ? '#1976d2' : 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
//             List View
//           </button>
//           <button onClick={() => setViewMode('history')} style={{ padding: '10px 20px', marginRight: '10px', backgroundColor: viewMode === 'history' ? 'white' : '#1565c0', color: viewMode === 'history' ? '#1976d2' : 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
//             Daily History
//           </button>
//           <button onClick={() => setViewMode('monthly')} style={{ padding: '10px 20px', backgroundColor: viewMode === 'monthly' ? 'white' : '#1565c0', color: viewMode === 'monthly' ? '#1976d2' : 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
//             Monthly Report
//           </button>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
//         {viewMode === 'map' ? (
//           /* Map View - unchanged */
//           <>
//             <div style={{ width: '350px', backgroundColor: '#f5f5f5', overflowY: 'auto', borderRight: '1px solid #ddd', padding: '15px' }}>
//               <h3>Active Users ({users.length})</h3>
//               {users.map(user => (
//                 <div key={user.id} onClick={() => openUserDetails(user)} style={{ padding: '15px', marginBottom: '10px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', cursor: 'pointer' }}>
//                   <strong>{user.name || 'Unknown User'}</strong><br />
//                   <small>ID: {user.device_id.substring(0, 12)}...</small><br />
//                   📍 {user.address || "Fetching..."}<br />
//                   🚶 <strong>{parseFloat(user.daily_distance_km || 0).toFixed(2)} KM today</strong><br />
//                   <small>Updated: {new Date(user.last_updated).toLocaleTimeString('en-IN')}</small>
//                 </div>
//               ))}
//             </div>
//             <div style={{ flex: 1 }}>
//               <MapContainer center={[19.11, 72.88]} zoom={11} style={{ height: '100%', width: '100%' }}>
//                 <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap contributors' />
//                 {users.map(user => (
//                   <Marker key={user.id} position={[parseFloat(user.latitude), parseFloat(user.longitude)]}>
//                     <Popup>
//                       <strong>{user.name || 'User'}</strong><br />
//                       📍 {user.address}<br />
//                       🚶 <strong>{parseFloat(user.daily_distance_km || 0).toFixed(2)} KM today</strong><br />
//                       <small>Updated: {new Date(user.last_updated).toLocaleString('en-IN')}</small>
//                     </Popup>
//                   </Marker>
//                 ))}
//               </MapContainer>
//             </div>
//           </>
//         ) : viewMode === 'list' ? (
//           /* List View - unchanged */
//           <div style={{ flex: 1, padding: '20px', overflowY: 'auto' }}>
//             <h3>All Users - List View</h3>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '15px' }}>
//               {users.map(user => (
//                 <div key={user.id} onClick={() => openUserDetails(user)} style={{ padding: '20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', cursor: 'pointer' }}>
//                   <h4>{user.name || 'Unknown User'}</h4>
//                   <p><strong>Device ID:</strong> {user.device_id}</p>
//                   <p><strong>Location:</strong> {user.address || "Unknown"}</p>
//                   <p><strong>Distance Today:</strong> <span style={{ fontSize: '1.3em', color: '#1976d2', fontWeight: 'bold' }}>{parseFloat(user.daily_distance_km || 0).toFixed(2)} KM</span></p>
//                   <p><strong>Last Seen:</strong> {new Date(user.last_updated).toLocaleString('en-IN')}</p>
//                   <button style={{ padding: '8px 16px', backgroundColor: '#1976d2', color: 'white', border: 'none', borderRadius: '5px' }}>View Full History →</button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ) : viewMode === 'history' ? (
//           /* Daily History - NOW WITH PRICING */
//           <div style={{ flex: 1, padding: '20px', overflowY: 'auto', backgroundColor: '#f9f9f9' }}>
//             <h3>Daily Historical Data</h3>
//             <div style={{ marginBottom: '20px' }}>
//               <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Select Date:</label>
//               <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} dateFormat="yyyy-MM-dd" maxDate={new Date()} />
//             </div>

//             {loadingHistorical ? (
//               <p>Loading data...</p>
//             ) : historicalData.length === 0 ? (
//               <p>No data available for this date.</p>
//             ) : (
//               <>
//                 {/* Summary */}
//                 <div style={{ backgroundColor: '#e3f2fd', padding: '20px', borderRadius: '10px', marginBottom: '30px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
//                   <h3 style={{ margin: '0 0 15px 0' }}>Summary for {selectedDate.toLocaleDateString('en-IN')}</h3>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.2em' }}>
//                     <div>
//                       <strong>Total Distance:</strong> {historicalData.reduce((sum, u) => sum + u.total_km, 0).toFixed(2)} KM
//                     </div>
//                     <div>
//                       <strong>Total Pricing (₹{PRICE_PER_KM}/KM):</strong> 
//                       <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>
//                         ₹{(historicalData.reduce((sum, u) => sum + u.total_km, 0) * PRICE_PER_KM).toFixed(2)}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 {/* User Cards */}
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
//                   {historicalData.map(user => {
//                     const userPricing = (user.total_km * PRICE_PER_KM).toFixed(2);
//                     return (
//                       <div key={user.id} style={{ padding: '20px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
//                         <h4>{user.name || 'Unknown User'} ({user.device_id})</h4>
//                         <div style={{ margin: '15px 0', fontSize: '1.1em' }}>
//                           <strong>Distance:</strong> {user.total_km.toFixed(2)} KM<br />
//                           <strong>Pricing (₹{PRICE_PER_KM}/KM):</strong> 
//                           <span style={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '1.2em' }}> ₹{userPricing}</span>
//                         </div>
//                         <details>
//                           <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginTop: '10px' }}>
//                             View {user.locations.length} Location Entries
//                           </summary>
//                           <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
//                             <thead>
//                               <tr style={{ backgroundColor: '#f0f0f0' }}>
//                                 <th style={{ padding: '8px', textAlign: 'left' }}>Time</th>
//                                 <th style={{ padding: '8px', textAlign: 'left' }}>Address</th>
//                                 <th style={{ padding: '8px', textAlign: 'left' }}>KM at Time</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {user.locations.map((loc, i) => (
//                                 <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
//                                   <td style={{ padding: '8px' }}>{new Date(loc.created_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</td>
//                                   <td style={{ padding: '8px' }}>{loc.address || "Unknown"}</td>
//                                   <td style={{ padding: '8px' }}>{parseFloat(loc.daily_distance_km || 0).toFixed(2)}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </details>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </>
//             )}
//           </div>
//         ) : (
//           /* Monthly Report - unchanged from previous */
//           <div style={{ flex: 1, padding: '20px', overflowY: 'auto', backgroundColor: '#f9f9f9' }}>
//             <h3>Monthly Distance & Pricing Report</h3>
//             <div style={{ marginBottom: '20px' }}>
//               <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Select Month:</label>
//               <DatePicker
//                 selected={selectedMonth}
//                 onChange={(date) => setSelectedMonth(date)}
//                 dateFormat="MMMM yyyy"
//                 showMonthYearPicker
//                 maxDate={new Date()}
//               />
//             </div>

//             {loadingMonthly ? (
//               <p>Loading monthly report...</p>
//             ) : monthlyReport.length === 0 ? (
//               <p>No data available for {selectedMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}.</p>
//             ) : (
//               <>
//                 <h4 style={{ marginBottom: '20px' }}>
//                   Month: <strong>{selectedMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}</strong>
//                 </h4>
//                 <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
//                   <thead>
//                     <tr style={{ backgroundColor: '#1976d2', color: 'white' }}>
//                       <th style={{ padding: '15px', textAlign: 'left' }}>User Name</th>
//                       <th style={{ padding: '15px', textAlign: 'center' }}>Total Distance (KM)</th>
//                       <th style={{ padding: '15px', textAlign: 'center' }}>Pricing (₹{PRICE_PER_KM}/KM)</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {monthlyReport.map((user, i) => (
//                       <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
//                         <td style={{ padding: '15px' }}>{user.name}</td>
//                         <td style={{ padding: '15px', textAlign: 'center', fontWeight: 'bold' }}>{user.total_km} KM</td>
//                         <td style={{ padding: '15px', textAlign: 'center', fontWeight: 'bold', color: '#d32f2f' }}>
//                           ₹{user.pricing.toFixed(2)}
//                         </td>
//                       </tr>
//                     ))}
//                     <tr style={{ backgroundColor: '#e3f2fd', fontWeight: 'bold' }}>
//                       <td style={{ padding: '15px' }}>TOTAL</td>
//                       <td style={{ padding: '15px', textAlign: 'center' }}>
//                         {monthlyReport.reduce((sum, u) => sum + u.total_km, 0).toFixed(2)} KM
//                       </td>
//                       <td style={{ padding: '15px', textAlign: 'center', color: '#d32f2f' }}>
//                         ₹{monthlyReport.reduce((sum, u) => sum + u.pricing, 0).toFixed(2)}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </>
//             )}
//           </div>
//         )}
//       </div>

//       {/* User Details Modal - unchanged */}
//       {selectedUser && (
//         <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={closeModal}>
//           <div style={{ backgroundColor: 'white', width: '90%', maxWidth: '800px', maxHeight: '90vh', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }} onClick={e => e.stopPropagation()}>
//             <div style={{ padding: '20px', backgroundColor: '#1976d2', color: 'white' }}>
//               <h2 style={{ margin: 0 }}>Location History - {selectedUser.name || 'User'}</h2>
//               <button onClick={closeModal} style={{ float: 'right', background: 'none', border: 'none', color: 'white', fontSize: '1.5em', cursor: 'pointer' }}>×</button>
//             </div>
//             <div style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
//               {loadingHistory ? <p>Loading...</p> : userHistory.length === 0 ? <p>No history.</p> : (
//                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                   <thead><tr style={{ backgroundColor: '#f0f0f0' }}><th style={{ padding: '10px', textAlign: 'left' }}>Time</th><th style={{ padding: '10px', textAlign: 'left' }}>Address</th><th style={{ padding: '10px', textAlign: 'left' }}>Distance (KM)</th></tr></thead>
//                   <tbody>
//                     {userHistory.map((loc, i) => (
//                       <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
//                         <td style={{ padding: '10px' }}>{new Date(loc.created_at).toLocaleString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</td>
//                         <td style={{ padding: '10px' }}>{loc.address || "Unknown"}</td>
//                         <td style={{ padding: '10px', fontWeight: 'bold' }}>{parseFloat(loc.daily_distance_km || 0).toFixed(2)}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default App;

// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import ProtectedRoute from './ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;